<template>
    <v-select
        solo
        hide-details
        label="Sort"
        v-bind:items="items"
        v-bind:value="value"
        v-on:change="onChange"
    ></v-select>
</template>

<script>
export default {
    props: {
        // Example item: { text: 'Newest', value: 'created_at:desc' }
        items: Array,
        value: String
    },
    methods: {
        onChange(event) {
            // Notify value change first and then emit custom event
            this.$emit('input', event);
            this.$emit('request-sort');
        }
    }
};
</script>
